      // Function to get the user's country code using the ipapi.co API
      function getCountryCode(callback) {
        const apiUrl = "https://ipapi.co/country/";

        // Make a fetch request to the API
        fetch(apiUrl)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.text();
          })
          .then((countryCode) => {
            callback(countryCode.trim()); // Trim to remove any leading/trailing whitespace
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }

      // Function to redirect the user based on their country code
      function redirectByCountry(countryCode) {
        switch (countryCode) {
          case "CA": // Example: Redirect visitors from Canada to a Canada-specific URL
            window.location.href = "https://belowzeroswiss.ca/";
        }
      }

      // Usage: Get the country code and redirect the user
      getCountryCode(redirectByCountry);